export * from './aviso-rpa.component';
